<template>
  <div class="header-right">
    <el-dropdown @command="handleCommand">
      <div style="display: flex; align-items: center; cursor: pointer;">
        <el-avatar :src="userAvatar" size="medium"></el-avatar>
        <span style="margin-left: 5px; color: #333;">{{ userName }}</span>
        <i class="el-icon-caret-bottom" style="margin-left: 5px;"></i>
      </div>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="profile">个人信息</el-dropdown-item>
        <el-dropdown-item command="changePwd">修改密码</el-dropdown-item>
        <el-dropdown-item command="logout" divided>退出登录</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getUserInitInfo } from '@/api/user';

export default {
  name: 'LayoutHeader',
  computed: {
    ...mapState('user', ['userInfo']),
    userName() {
      return this.userInfo.username || '管理员'
    },
    userAvatar() {
      return this.userInfo.avatar || 'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png'
    }
  },
  create() {
    this.getUserInitInfo();
  },
  mounted() {
    this.getUserInitInfo();
  },
  methods: {
    getUserInitInfo() {
      getUserInitInfo().then(res => {
        this.userInfo.username = res.user.userName;
      }).catch(err => {
        
      })
    },
    handleCommand(command) {
      if (command === 'logout') {
        // 简化：只调用Vuex的Logout action，逻辑统一收敛
        this.$confirm('确定要退出登录吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$store.dispatch('user/Logout').then(() => {
            this.$router.push('/login')
            this.$message.success('退出登录成功！')
          })
        }).catch(() => {})
      } else if (command === 'profile') {
        this.$router.push('/profileSetting')
      } else if (command === 'changePwd') {
        this.$router.push('/updatePassword')
      }
    }
  }
}
</script>

<style scoped>
.header-right {
  display: flex;
  align-items: center;
}
</style>